import axios from 'axios'

const baseHost = window.env && window.env.baseHost

const request = axios.create({
  baseURL: `${baseHost}/api/v1/cart`
})

export default request
